class OpalThemeOwlCarousel {

}

new OpalThemeOwlCarousel();


